class OpalThemeOwlCarousel {

}

new OpalThemeOwlCarousel();


